import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import ButtonSmall from 'components/Typography/ButtonSmall';
import Icon from 'components/DesignSystem/Icon';
import { IconType } from 'components/DesignSystem/Icon/icons';
import TooltipWrapper from 'components/DesignSystem/TooltipWrapper';

import './index.scss';

export default function SimpleOption({
  link,
  icon,
  isCollapsed,
  children,
  locked = false,
  onClick,
}: {
  link: string;
  icon: IconType;
  isCollapsed: boolean;
  children: any;
  locked?: boolean;
  onClick?: () => void;
}) {
  const location = useLocation();
  const active = location.pathname.startsWith(link);

  return (
    <Link to={link} className="text-decoration-none" onClick={onClick}>
      <div className={`sidebar-item ${active ? 'active' : ''}`}>
        <div className="sidebar-item-icon"><Icon iconType={icon} color="currentColor" /></div>
        {!isCollapsed && (
          <div className="sidebar-item-label">
            <ButtonSmall>{children}</ButtonSmall>
          </div>
        )}
        {!isCollapsed && locked && (
          <TooltipWrapper placement="right" className="locked-icon" title="Produto não contratado">
            <div className="float-end">
              <Icon iconType="locked" />
            </div>
          </TooltipWrapper>
        )}
      </div>
    </Link>
  );
}
